module.exports = __webpack_public_path__ + "img/all.332f393d.png";